export default __webpack_public_path__ + "static/media/logoThreejs.0b93dc40.png";